<template>
    <b-overlay :show="loading" class="content">
        <div class="mb-3 text-center">
            <hr />
            <strong>اقدام های انجام شده روی درخواست</strong>
            <hr />
        </div>

        <div v-if="requestStatus != 4">
            <table v-if="screenWidth > 1021"
                   class="table table-bordered bg-white table-striped text-center">
                <thead>
                    <tr>
                        <th v-for="field in fields" v-if="field.showCell" :key="field.key">
                            {{ $t("param." + field.key) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items"
                        v-if="!item.master && item.requestTypeStatusId != 4">
                        <td v-for="field in fields" v-if="field.showCell">
                            <div v-html="item[field.key]"></div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table v-if="screenWidth < 1024 && !item.master && item.requestTypeStatusId != 4"
                   v-for="(item, index) in items"
                   class="table table-light table-sm table-silver table-mobile mb-2 text-right">
                <tr v-for="field in fields" v-if="field.showCellMobile">
                    <th>
                        {{ $t("param." + field.key) }}
                    </th>
                    <td>
                        <div v-html="item[field.key] "></div>
                    </td>
                </tr>
            </table>
        </div>
        <div v-else>

            <div class="alert alert-danger text-right">
                <span>درخواست شما تایید نشده است!</span>
            </div>

            <table v-if="screenWidth > 1021"
                   class="table table-bordered bg-white table-striped text-center">
                <thead>
                    <tr>
                        <th v-for="field in fields" v-if="field.showCell" :key="field.key">
                            {{ $t("param." + field.key) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items"
                        v-if="!item.master && item.actionTaken">
                        <td v-for="field in fields" v-if="field.showCell">
                            <div v-html="item[field.key]"></div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table v-if="screenWidth < 1024 && !item.master && item.actionTaken"
                   v-for="(item, index) in items"
                   class="table table-light table-sm table-silver table-mobile mb-2 text-right">
                <tr v-for="field in fields" v-if="field.showCellMobile">
                    <th>
                        {{ $t("param." + field.key) }}
                    </th>
                    <td>
                        <div v-html="item[field.key] "></div>
                    </td>
                </tr>
            </table>
        </div>


    </b-overlay>
</template>
<script>
    export default {

        props: {
            requestId: 0
        },

        data()
        {
            return {
                screenWidth: null,
                loading: false,
                requestStatus : 0,
                selected: {},
                items: [],
                fields: [
                    {
                        key: "requestId",
                        showCell: false,
                        shotDetails: false
                    },
                    {
                        key: "requestTypeName",
                        showCell: true,
                        shotDetails: true,
                        showCellMobile: true,
                        cardNumber: true
                    },
                    {
                        key: "orderNumber",
                        showCell: false,
                        shotDetails: false
                    },
                    {
                        key: "actionTakenName",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: false
                    },
                    {
                        key: "personnelFullName",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: false
                    },
                    {
                        key: "personnelRolName",
                        showCell: true,
                        shotDetails: false,
                        showCellMobile: true,

                    },
                    {
                        key: "persianCreateDate",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true
                    },
                    {
                        key: "createTime",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true
                    },
                    {
                        key: "comment",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true
                    }
                ],
            };
        },

        beforeMount()
        {
            this.screenWidth = window.outerWidth;
            this.initTable();
        },


        methods: {
            initTable()
            {
                this.loading = true;

                const data = {
                    RequestID: this.requestId
                };

                axios({ method: "post", url: "/api/App/GetCustomerRequest", data: data })
                    .then(response =>
                    {
                        if (response.data.meta.requests[0].requestTypeStatusId == 4)
                        {
                            this.requestStatus = 4
                        }

                        this.items = response.data.meta.requests;
                        this.totalRows = response.data.meta.totalRows;
                        this.totalFilteredRows = response.data.meta.totalFilteredRows;
                        this.loading = false;
                    })
                    .catch(error => { });
            },
        }
    };
</script>
